import cns from 'classnames';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { css } from '@emotion/react';

export const ICON_CLASSNAME = '__mapui_icon';

const applyMainStyles = () => (theme) => {
  const defaultStyle = css(theme.icon.defaultStyles);

  const styles = [defaultStyle];

  return css(...styles);
};

export type IconProps = FontAwesomeIconProps;

export const Icon = ({ className, icon, ...others }: IconProps) => (
  <FontAwesomeIcon
    css={applyMainStyles()}
    className={cns(ICON_CLASSNAME, className)}
    icon={icon}
    {...others}
  />
);
